import StickyWallpaper from '../components/StickyWallpaper'
import Navbar from '../components/Navbar'
import HeroSection from '../components/HeroSection'
import QuickPitchSection from '../components/QuickPitchSection'
import VisualExplainerSection from '../components/VisualExplainerSection'
import RoadmapSection from '../components/RoadmapSection'
import FinalSection from '../components/FinalSection'
import PageWrapper from '../components/PageWrapper'

interface LandingPageProps {
  onOpenTerminal: () => void
}

export default function LandingPage({ onOpenTerminal }: LandingPageProps) {
  return (
    <main className="relative bg-black">
      <Navbar onOpenTerminal={onOpenTerminal} />
      <StickyWallpaper />
      
      <div className="relative z-20">
        <HeroSection />
        
        <PageWrapper>
          <QuickPitchSection />
        </PageWrapper>
        
        <PageWrapper>
          <VisualExplainerSection />
        </PageWrapper>
        
        <PageWrapper>
          <RoadmapSection />
        </PageWrapper>
        
        <PageWrapper>
          <FinalSection />
        </PageWrapper>
      </div>
    </main>
  )
}